import { FC } from 'react';

import ProductFormulationTypeListing from 'components/main/ProductFormulationType';

const ProductType: FC = () => <ProductFormulationTypeListing />;

export default ProductType;
